import { Outlet } from '@/core/entity';
import { IOutletGateway, OutletInput, UpdaterFunc, PresenterFunc } from '@/core/interface';

export class CreateOutlet {
  constructor(
    private readonly outletGw: IOutletGateway,
  ) { }

  public async execute(input: OutletInput, presenter: PresenterFunc<Outlet | null>, updater?: UpdaterFunc) {
    presenter(null, null, true);

    try {
      const result = await this.outletGw.createOutlet(input, undefined, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
